type styleTypes = 'forms';

/**
 * Helper to opt out of styles applied to pages via scss
 * New blocks of styles can be added as "opt-outable" by wrapping the block in htmL:not(.sass-opt-out-"your-style") {
 *   ... styles to opt out of
 * }
 * @param styleType
 */
export const sassOptOut = (styleType: styleTypes | Array<styleTypes>) => {
  const _styleType = Array.isArray(styleType) ? styleType : [styleType];
  const classNames = _styleType.map(style => `sass-opt-out-${style}`);

  document.getElementsByTagName('html')[0]?.classList.add(...classNames);
};
